import action from '../../../abstract/action.js';

export default action({
  label: 'Podgląd',
  icon: 'EyeIcon',
  main: ({ item }) => item.zusdeclarationspackages?.status === 'Przesyłka przyjęta do ZUS',
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'zus-declarations-show', params: { id } }),
});
